import { Module, MutationTree, ActionTree, GetterTree } from "vuex"
import { RootState } from "../../index"
import { Controller, Device } from "../../../types/setup"

export interface DeviceState {
    deviceType: string
    controller: Controller | null
    p1wifi: Controller | null
    devices: Device[]
}

const state: DeviceState = {
    deviceType: "",
    controller: null,
    p1wifi: null,
    devices: [],
}

const mutations: MutationTree<DeviceState> = {
    setDeviceType(state, deviceType: string) {
        state.deviceType = deviceType
    },
    setController(state, controller: Controller) {
        state.controller = controller
    },
    setP1Wifi(state, controller: Controller) {
        state.p1wifi = controller
    },
    setDevices(state, devices: Device[]) {
        state.devices = devices
    },
    resetUnit(state) {
        state.controller = null
        state.p1wifi = null
        state.devices = []
    },
}

const actions: ActionTree<DeviceState, RootState> = {
    async setDeviceType({ commit }, deviceType: string) {
        commit("setDeviceType", deviceType)
    },

    completeControllerStep({ commit, state }, { controller, devices }) {
        if (state.deviceType === "controller") {
            commit("setController", controller)
        } else {
            commit("setP1Wifi", controller)
        }

        commit("setDevices", devices)
    },

    resetUnit({ commit }) {
        commit("resetUnit")
    },
}

const getters: GetterTree<DeviceState, RootState> = {
    deviceType: (state) => state.deviceType,
    currentController: (state) => {
        return state.deviceType === "controller" ? state.controller : state.p1wifi
    },
    currentDevices: (state) => state.devices,
    canContinue: (state) => {
        return state.deviceType === "controller" ? !!state.controller : !!state.p1wifi
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
} as Module<DeviceState, RootState>
